<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <label for="form-organization-position" class="control-label">{{ inputLabel }}</label>
    <select
      v-model="inputValue"
      :disabled="disabled"
      id="form-organization-position"
      class="form-control"
      @change="emit($event)"
    >
      <option
        v-for="organizationSubdivision in items"
        :key="organizationSubdivision.id"
        :value="organizationSubdivision.id"
      >
        {{ organizationSubdivision.name }}
      </option>
    </select>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import organizationSectionMixin from '../../../../mixins/application-form/organizationSectionMixin'
import organizationInputMixin from '../../../../mixins/application-form/organizationInputMixin'

export default {
  name: 'OrganizationSubdivisionInput',

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    organizationSectionMixin,
    organizationInputMixin
  ],

  props: {
    inputLabel: {
      default: 'Подразделение заявителя'
    },

    inputName: {
      default: 'organization_subdivision_id'
    },

    items: {
      type: [Array, Object],
      default: () => []
    }
  }
}
</script>
